module.exports = __webpack_public_path__ + "static/media/full_brand_logo.193cfc81.svg";